import * as React from 'react';
import { css } from '@emotion/css';
import clsx from 'clsx';
import { style } from './Loader.style';
import { getAlignmentClassName, getWidthClassName, Props } from './LoaderTypes';

export const IhhLoader = ({
  size = 'medium',
  testId,
  wrapperHeight = 'auto',
  fullScreen = false,
  center,
  ...otherProps
}: Props) => (
  <div
    className={clsx(style.wrapper, css({ height: wrapperHeight }), {
      [style.fullScreen]: fullScreen,
    })}
  >
    <svg
      data-testid={testId}
      id="ed4C2zWBfFN1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 283.5 283.5"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      className={clsx(
        css({
          shapeRendering: 'auto',
          display: 'block',
        }),
        getWidthClassName(size),
        getAlignmentClassName(center),
      )}
      preserveAspectRatio="xMidYMid"
      {...otherProps}
    >
      <style>
        {
          '@keyframes ed4C2zWBfFN2_c_o{0%,33.333333%,66.666667%,to{opacity:1}16.666667%,50%,83.333333%{opacity:.1}}'
        }
      </style>
      <g
        id="a256fcd9-177b-4edb-a166-4a5c6ddd427f"
        data-name="Layer 2"
        style={{
          animation: 'ed4C2zWBfFN2_c_o 3000ms linear infinite normal forwards',
        }}
      >
        <g id="b46aa2bd-69ba-489c-910d-28ab7d2773be" data-name="Layer 1">
          <path fill="#3ba0bf" d="M85.7,102.7c7.9,2,6,8.5-4.2,14.4-10.3,5.9-25,9.1-32.9,7-7.9-2-6-8.5,4.2-14.4,10.2-5.9,25-9.1,32.9-7" />
          <path fill="#3ba0bf" d="M136.4,77.8c6.6,1.9,5.1,7.6-3.3,12.7-8.4,5.1-20.5,7.7-27,5.8-6.6-1.9-5.1-7.6,3.3-12.7,8.4-5.1,20.5-7.7,27-5.8" />
          <path fill="#3ba0bf" d="M183.3,66.3c4.9,1.4,3.8,5.7-2.4,9.5-6.2,3.8-15.3,5.7-20.2,4.3-4.9-1.4-3.8-5.7,2.4-9.5,6.3-3.8,15.3-5.7,20.2-4.3" />
          <path fill="#00769c" d="M86,173.3c12.5,3.2,9.5,13.4-6.7,22.8-16.2,9.4-39.4,14.4-51.9,11.1-12.5-3.2-9.5-13.4,6.7-22.8,16.2-9.4,39.4-14.3,51.8-11.1" />
          <path fill="#00a3a8" d="M57.4,141c9.6,2.5,7.3,10.4-5.1,17.6-12.4,7.2-30.3,11.1-39.9,8.6-9.6-2.5-7.3-10.3,5.1-17.6,12.4-7.2,30.3-11,39.9-8.5" />
          <path fill="#00a3a8" d="M232.3,68.4c6.2,2,4.9,7.7-2.9,12.7-7.9,5-19.3,7.4-25.5,5.4-6.2-2-4.9-7.7,2.9-12.7,7.9-5,19.3-7.4,25.5-5.4" />
          <path fill="#00769c" d="M198.4,167.5c17.9,5.7,13.3,21.1-10.3,34.4-23.6,13.2-57.3,19.3-75.3,13.6-17.9-5.7-13.3-21.1,10.3-34.3,23.6-13.3,57.3-19.4,75.3-13.6" />
          <path fill="#00769c" d="M265.2,124.4c11.1,3.4,8.7,13.3-5.4,22.1-14.1,8.8-34.5,13.1-45.5,9.7-11.1-3.4-8.7-13.4,5.4-22.1,14.1-8.8,34.4-13.1,45.5-9.6" />
          <path fill="#00a3a8" d="M272,85c8,2.8,6.4,10.4-3.5,16.9-9.9,6.5-24.4,9.6-32.3,6.8-8-2.8-6.4-10.4,3.5-16.9,9.9-6.6,24.4-9.6,32.3-6.8" />
        </g>
      </g>
    </svg>
  </div>
);
